import Header from "../components/Header";
import {EyeOff, Plus} from "react-feather";
import {NavLink} from "react-router-dom";
import Empty from "../components/Empty";
import {useEffect, useState} from "react";
import Data from "../../Data";
import Error from "../components/Error";
import Meta from "../../../components/Meta";
import {formatDuration} from "../../utils/duration";

const PAGE_SIZE = 20;

const Experiences = () => {

    const [experiences, setExperiences] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(async () => {
        try {
            setLoading(true);
            const result = await Data.fetchExperiencesPage({ page, pageSize: PAGE_SIZE });
            setExperiences(result.data.data);
            setTotalPages(result.data.totalPages);
        } catch(error){
            setError(true)
        } finally {
            setLoading(false)
        }
    }, [page]);

    return (
        <>
            <Meta title={"Experiences"} />
            <Header heading={"Experiences"} buttonLabel={"Create Experience"} buttonIcon={<Plus size={20} /> } buttonTo={"/admin/experiences/create"} />
            <div className={"p-3 lg:p-6 grid grid-cols-1 gap-3 lg:gap-6 w-full"}>

                {error ? <Error message={"Unable to load experiences, please refresh the page."}/> : null}

                {loading ?
                    <Empty>
                        <p>Loading...</p>
                    </Empty>
                    : experiences.length === 0 ?
                        <Empty>
                            <p>No Experiences</p>
                        </Empty>
                        :

                        <>
                        <div className={"w-full overflow-x-auto"} style={{ WebkitOverflowScrolling: 'touch' }}>
                        <table
                            className={"min-w-[760px] w-full border-collapse outline outline-1 outline-gray-200 rounded-lg overflow-hidden drop-shadow-sm"}>
                            <thead className={"bg-gray-50"}>
                            <tr>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Name</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Status</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Upcoming Events</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Duration</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Price</th>
                                <th className={"text-left px-4 py-3 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>Actions</th>
                            </tr>
                            </thead>
                            <tbody className={"bg-white"}>
                            {experiences.map((experience, index) => (
                                <tr className={"border-t"} key={index}>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>{experience.name}</td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>{experience.isPublished ? "Published" : "Unpublished"}</td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>{experience.futureEventsCount > 0 ? experience.futureEventsCount : '--'}</td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>{formatDuration(experience.duration)}</td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>&pound;{experience.price} per ticket</td>
                                    <td className={"px-4 py-2 lg:px-6 lg:py-4 truncate overflow-ellipsis"}>
                                        <div className={"flex gap-2"}>
                                            <NavLink to={`/admin/experiences/${experience._id}`}
                                                     className={"bg-backgroundGrey px-2.5 py-1 rounded hover:opacity-80 transition"}>View</NavLink>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                            </tbody>
                        </table>
                        </div>

                        <div className={"flex items-center gap-2 justify-center"}>
                            <button
                                onClick={() => setPage(p => Math.max(1, p - 1))}
                                disabled={page <= 1}
                                className={`px-2.5 py-1.5 rounded-md border ${page <= 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                                Prev
                            </button>
                            <span className={"text-textGrey text-sm"}>Page {page} of {totalPages}</span>
                            <button
                                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                                disabled={page >= totalPages}
                                className={`px-2.5 py-1.5 rounded-md border ${page >= totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
                            >
                                Next
                            </button>
                        </div>
                        </>
                }
            </div>
        </>
    )
}

export default Experiences
